import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function DeleteIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.6052 1.99999H13.4153C14.5138 1.99999 15.3333 2.93595 15.3333 4C15.3333 4.59142 15.0801 5.14327 14.6666 5.51682V14.267C14.6666 15.2185 13.9035 16.0001 12.9448 16.0001H3.05495C2.09623 16.0001 1.33318 15.2185 1.33318 14.267V5.51682C0.919657 5.14327 0.666504 4.59142 0.666504 4C0.666504 2.93595 1.48595 1.99999 2.58447 1.99999H5.39473C6.06692 -0.666744 9.933 -0.666744 10.6052 1.99999ZM9.18041 1.99999C8.68174 1.11105 7.31818 1.11105 6.81951 1.99999H9.18041ZM5.99995 7.99999C5.99995 7.6318 5.70147 7.33332 5.33328 7.33332C4.96508 7.33332 4.6666 7.6318 4.6666 7.99999L4.6666 12.6667C4.6666 13.0349 4.96508 13.3334 5.33328 13.3334C5.70147 13.3334 5.99995 13.0349 5.99995 12.6667V7.99999ZM7.99996 7.33332C8.36815 7.33332 8.66663 7.6318 8.66663 7.99999V12.6667C8.66663 13.0349 8.36815 13.3334 7.99996 13.3334C7.63177 13.3334 7.33329 13.0349 7.33329 12.6667V7.99999C7.33329 7.6318 7.63177 7.33332 7.99996 7.33332ZM11.3333 7.99999C11.3333 7.6318 11.0348 7.33332 10.6666 7.33332C10.2985 7.33332 9.99997 7.6318 9.99997 7.99999V12.6667C9.99997 13.0349 10.2985 13.3334 10.6666 13.3334C11.0348 13.3334 11.3333 13.0349 11.3333 12.6667V7.99999ZM1.99985 4C1.99985 3.59129 2.30084 3.33333 2.58447 3.33333H13.4153C13.6989 3.33333 13.9999 3.59129 13.9999 4C13.9999 4.40872 13.6989 4.66667 13.4153 4.66667H2.58447C2.30084 4.66667 1.99985 4.40872 1.99985 4ZM2.66652 6.00002H13.3333V14.267C13.3333 14.4956 13.1538 14.6667 12.9448 14.6667H3.05495C2.84603 14.6667 2.66652 14.4956 2.66652 14.267V6.00002Z"
          fill={theme?.palette?.text?.button}
        />
      </svg>
    </SvgIcon>
  );
}
